<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <UserRegister />
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import UserRegister from './UserRegister.vue';

export default {
  name: 'App',
  components: {
    //HelloWorld,
    UserRegister
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
